import request from '@/plugins/axios'

//获取资源操作记录列表
export function listLog(params) {
  return request({
    url: '/resourceLog/listLog',
    method: 'get',
    params
  })
}

//添加资源
export function addLog(data) {
  return request({
    url: '/resourceLog/addLog',
    method: 'post',
    data
  })
}

//数据
export function getOverview() {
  return request({
    url: '/data/overview/getOverview',
    method: 'get'
  })
}
